enum FulfillmentStatus {
  PLANNED = 'planned',
  CONFIRMED = 'confirmed',
  DELAYED_START = 'delayed_start',
  SKIPPED = 'skipped',
  CANCELLED = 'cancelled',
  SUSPENDED = 'suspended',
  ADMIN_ORDER_CANCELLED = 'admin_order_cancelled',
  RETURNING = 'returning',
  PENDING_CANCELLATION = 'pending_cancellation',
}

export default FulfillmentStatus;
